import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import Swal from 'sweetalert2';

import TrackerButton from '@/components/TrackerButton.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
//import TabBar from '@/components/TabBar.vue';
import Aside from '@/components/Aside.vue';
import Spinner from '@/components/Spinner.vue';
//import logo from '@handl-web/pz-ui/img/about.png';
import { LOGIN_PAGE, IDENTITY_PAGE, REFERRAL_PAGE } from '../../constants/routes';
import { LOADING_MESSAGE } from './Referral.constants';

export default {
  name: 'Referral',

  components: {
    WayFindBar,
    Footer,
    Aside,
    //TabBar,
    Spinner,
    TrackerButton,
  },

  data: () => {
    return {
      //logo,
      loadingMessage: LOADING_MESSAGE,
      selectedSeqId: -1,
      step: '',
      refChosen: 0,
      promiseGetYzRefs: null,
    };
  },

  computed: {
    ...mapState('Referral', {
      ms_refCode: 'refCode',
      ms_refRecords: 'refRecords',
      ms_referalMoney: 'referalMoney',
      ms_referalPoint: 'referalPoint',
      ms_refereeMoney: 'refereeMoney',
      ms_res_chooseYzRefs: 'res_chooseYzRefs',
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
      mg_identificationStatus: 'identificationStatus',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    c_referalMoney() {
      return 100 * this.ms_referalMoney;
    },

    c_referalPoint() {
      return 10 * this.ms_referalPoint;
    },

    c_refereeMoney() {
      return 100 * this.ms_refereeMoney;
    },

    c_selectedRecord() {
      const refRecord = _.find(
        this.ms_refRecords,
        (refRecord) => refRecord.seqId === this.selectedSeqId
      );
      return refRecord ? refRecord : {};
    },
  },

  methods: {
    ...mapActions('Referral', {
      ma_getYzRefs: 'getYzRefs',
      ma_chooseYzRefs: 'chooseYzRefs',
    }),

    copyRefCode() {
      this.$refs.refCode.select();
      document.execCommand('Copy');
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: '邀请码已复制',
        showConfirmButton: false,
        timer: 800,
      });
    },

    gotoLogin() {
      this.$router.push(`${LOGIN_PAGE}?login_redirect_uri=${encodeURIComponent(REFERRAL_PAGE)}`);
    },

    openModalRecord(seqId) {
      this.selectedSeqId = seqId;
      this.step = 'choose';
      this.refChosen = 0;
    },

    chooseRef(refChosen) {
      this.refChosen = refChosen;
    },

    _warnIdentificationStatus() {
      Swal.fire({
        icon: 'info',
        title: `实名认证审核中`,
        text: '实名认证审核中，请审核通过后再进行尝试。',
        showConfirmButton: true,
      });
    },

    async chooseYzRefs() {
      if (1 === this.refChosen || 1 === this.mg_identificationStatus) {
        await this.ma_chooseYzRefs({
          seqId: this.selectedSeqId,
          chosen: this.refChosen,
        });
        if (this.ms_res_chooseYzRefs) {
          this.step = 'chooseSucc';
        }
      } else if (0 === this.mg_identificationStatus) {
        Swal.fire({
          icon: 'info',
          title: '您还没有认证',
          text: '亲爱的学员请先完成认证',
          confirmButtonColor: '#3085d6',
          confirmButtonText: '去认证',
        }).then((result) => {
          if (result.value) {
            const identity_redirect_uri = `${REFERRAL_PAGE}?seqId=${this.selectedSeqId}&chosen=${this.refChosen}`;
            this.$router.push(
              `${IDENTITY_PAGE}?identity_redirect_uri=${encodeURIComponent(identity_redirect_uri)}`
            );
          }
        });
      } else if (2 === this.mg_identificationStatus) {
        this._warnIdentificationStatus();
        return;
      }
    },

    _ReferralCreated() {
      if (this.c_isLogin) {
        this.promiseGetYzRefs = this.ma_getYzRefs();
      }
    },

    async _ReferralMounted() {
      if (this.c_isLogin) {
        if (undefined !== this.$route.query.seqId) {
          if (2 === this.mg_identificationStatus) {
            this._warnIdentificationStatus();
            return;
          } else if (1 === this.mg_identificationStatus) {
            await this.promiseGetYzRefs;
            const refReferralOpenModalRecord = _.find(
              this.$refs.ReferralOpenModalRecords,
              (ReferralOpenModalRecord) =>
                `Referral-openModalRecord-${this.$route.query.seqId}` === ReferralOpenModalRecord.id
            );
            refReferralOpenModalRecord.click();
            await this.$nextTick();
            this.$refs[`ReferralChooseRef_${this.$route.query.chosen}`].click();
            await this.$nextTick();
            this.$refs.ReferralChooseYzRefs.click();
          }
        }
      }
    },
  },

  created() {
    this._ReferralCreated();
  },

  mounted() {
    this._ReferralMounted();
  },
};
